module.exports = __webpack_public_path__ + "img/logo1-firmas.2d17cf85.png";